import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as Icon from 'react-bootstrap-icons';

import styles from '../Modals.module.css';
import stylesModal from './SelectorAgendaModal.module.css';
import { colors } from '../../../types/types';

export const SelectorAgendaModal = ({ hide, evento, cita }) => {

    const { permisos } = useSelector(state => state.auth);

    return (
        <>
            <div className={styles.topCloseButtonContainer}>
                <div className={styles.topCloseButton} onClick={hide}>
                    <Icon.X color={colors.DANGER} size={30} />
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className={styles.modalHeader}>Tipo de evento</div>
                    </div>
                </div>
                <div className="row">
                    {(permisos.eventoCreate) &&
                    <div className="col">
                        <div className={"card p-2 " + stylesModal.card} onClick={evento}>
                            <div className='centrar pb-2'>
                                <Icon.CalendarRange color={colors.PRIMARY} size={70} />
                            </div>
                            <div className={'text-center ' + stylesModal.cardText}>Evento</div>
                        </div>
                    </div>}
                    {(permisos.citaCreate) &&
                    <div className="col">
                        <div className={"card p-2 " + stylesModal.card}>
                            <div className='centrar pb-2' onClick={cita}>
                                <Icon.Calendar2Plus color={colors.PRIMARY} size={70} />
                            </div>
                            <div className={'text-center ' + stylesModal.cardText}>Cita</div>
                        </div>
                    </div>}
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className={'text-center ' + stylesModal.infoText}>Selecciona el tipo de registro a crear</div>
                    </div>
                </div>
            </div>
        </>
    )
}

SelectorAgendaModal.propTypes = {
  hide: PropTypes.func.isRequired,
  evento: PropTypes.func.isRequired,
  cita: PropTypes.func.isRequired,
}